export default {
  conselhos: [],
  conselho: {
    mandatos: [],
  },
  pagination: {},
  layout: {},
};
